export function fromOption<T>(options: T[]) {
  return {
    findByKey(key: string, value: any) {
      return options.find((option: any) => option[key] === value) || null;
    },
  };
}
